(() => {
  'use strict';

  const EVENT_NAME = 'splitflask_timer';
  const TIMER_SELECTOR = '[data-sf-timer-popup]';
  const trackedEvents = new Set();
  const timerFormIds = new Set();
  let lastResultAt = 0;

  function eventId() {
    if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    return `sf-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }

  function publish(action, detail = {}, dedupeKey = action) {
    if (trackedEvents.has(dedupeKey)) return;
    trackedEvents.add(dedupeKey);

    const cleanDetail = Object.fromEntries(
      Object.entries(detail).filter(([, value]) => value !== undefined && value !== null && value !== '')
    );
    const payload = {
      action,
      event_id: eventId(),
      page_path: window.location.pathname,
      ...cleanDetail,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: EVENT_NAME,
      ...Object.fromEntries(Object.entries(payload).map(([key, value]) => [`sf_${key}`, value])),
    });

    try {
      const publication = window.Shopify?.analytics?.publish?.(EVENT_NAME, payload);
      publication?.catch?.(() => {});
    } catch (error) {
      // Analytics must never interrupt the storefront experience.
    }
  }

  function readStorage(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function getEligibility(root) {
    if (!root || root.dataset.enabled !== 'true') return { eligible: false, reason: 'disabled' };

    const path = window.location.pathname.toLowerCase();
    const excludedPaths = ['/cart', '/checkout', '/checkouts', '/account', '/orders', '/thank_you'];
    if (excludedPaths.some((excludedPath) => path.includes(excludedPath))) {
      return { eligible: false, reason: 'excluded_path' };
    }

    if (
      root.dataset.isSubscriber === 'true'
      || readStorage(window.localStorage, 'splitflask_marketing_subscriber') === 'true'
    ) {
      return { eligible: false, reason: 'subscriber' };
    }

    if (readStorage(window.sessionStorage, 'splitflask_timer_shown_session') === 'true') {
      return { eligible: false, reason: 'shown_this_session' };
    }

    const now = Date.now();
    if (Number(readStorage(window.localStorage, 'splitflask_timer_dismissed_until') || 0) > now) {
      return { eligible: false, reason: 'dismissed' };
    }
    if (Number(readStorage(window.localStorage, 'splitflask_timer_played_until') || 0) > now) {
      return { eligible: false, reason: 'played' };
    }

    return { eligible: true, reason: 'eligible' };
  }

  function captureConfiguredFormIds(root) {
    [root?.dataset.winnerFormId, root?.dataset.standardFormId]
      .filter(Boolean)
      .forEach((formId) => timerFormIds.add(String(formId)));
  }

  function isTimerForm(formId) {
    if (formId && timerFormIds.has(String(formId))) return true;
    return lastResultAt > 0 && Date.now() - lastResultAt < 15000;
  }

  window.addEventListener('splitflask:timer_open', () => publish('impression'));
  window.addEventListener('splitflask:timer_start', () => publish('start'));
  window.addEventListener('splitflask:timer_dismiss', () => publish('dismiss'));
  window.addEventListener('splitflask:timer_result', (event) => {
    lastResultAt = Date.now();
    const outcome = String(event.detail?.outcome || 'unknown');
    publish('result', {
      outcome,
      stopped_at: event.detail?.stoppedAt,
      stopped_at_hundredths: event.detail?.stoppedAtHundredths,
    }, `result:${outcome}`);
  });
  window.addEventListener('splitflask:klaviyo_form_requested', (event) => {
    const formId = String(event.detail?.formId || '');
    if (formId) timerFormIds.add(formId);
    publish('form_requested', {
      form_id: formId,
      outcome: event.detail?.outcome,
    }, `form_requested:${formId || 'unknown'}`);
  });
  window.addEventListener('klaviyoForms', (event) => {
    const type = String(event.detail?.type || '');
    const formId = String(event.detail?.formId || '');
    if (!isTimerForm(formId)) return;

    if (type === 'open' || type === 'embedOpen') {
      publish('form_open', { form_id: formId }, `form_open:${formId || 'unknown'}`);
    } else if (type === 'submit') {
      publish('form_submit', { form_id: formId }, `form_submit:${formId || 'unknown'}`);
    } else if (type === 'stepSubmit') {
      publish('form_step_submit', {
        form_id: formId,
        step_name: event.detail?.metaData?.$step_name,
      }, `form_step_submit:${formId || 'unknown'}:${event.detail?.metaData?.$step_name || 'unknown'}`);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector(TIMER_SELECTOR);
    if (!root) return;
    captureConfiguredFormIds(root);
    const eligibility = getEligibility(root);
    publish('eligibility', eligibility);
  });
})();
